import { ConfigService } from './../../services/webFeeder/config.service';
import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractItem } from '@business/base/abstract-item';
import { AbstractItemService } from '@business/base/abstract-item.service';
import { MessageQuote } from '@model/webFeeder/message-quote.model';
import { QuoteService } from '@services/webFeeder/sckt-quotes.service';
import { WorkspaceNewService } from '@services/workspace-new.service';
import { AppUtils } from '@utils/app.utils';
import { Constants } from '@utils/constants';
import { Subscription, of } from 'rxjs';
import { MarketEnum } from '@model/enum/market.enum';
import { SimpleOrder } from '@model/simpleOrder';
import { ConfigCardsModel } from '@model/config-comp-settings.model';


@Component({
  selector: Constants.WINDOW_NAME_BOOK,
  templateUrl: './book.template.html',
  encapsulation: ViewEncapsulation.None,
})
export class BookControllerComponent extends AbstractItem implements OnInit, OnDestroy {

  @Input() override data: any;
  override dialog: MatDialog;
  componentName = Constants.TITLE_CARD_BOOK;
  removeFromWksTooltip = Constants.TOOLTIP_REMOVE_WKS_TOOL;
  toolTipCenterStaircaseON = Constants.TOOLTIP_CENTER_STAIRCASE_ON;
  toolTipCenterStaircaseOFF = Constants.TOOLTIP_CENTER_STAIRCASE_OFF;
  forceConfigCenterElement: boolean;
  priceTheory: number;
  varTheory: string;
  timeToOpen: string;
  model: SimpleOrder = new SimpleOrder();
  oldSymbolTemp: string;
  private _subscriptionQuote: Subscription;
  hiddenInvalid: boolean;
  loadingImgName: boolean;
  isSubscribeBook: boolean;
  isUpdateOnDemand: boolean;
  initialPrice: boolean;
  company = '';
  messageQuote: MessageQuote = new MessageQuote();
  imgName: any;
  variation: any;
  coinVariation: any;
  lastTrade: any;
  showVariation: boolean;
  tabIndex = 0;
  loading = true;
  hasSubscribeBook = false;
  hasSubscribeAggregated = false;
  valueInitBookStaircase: any = [];
  tickSize = 2;

  constructor(
    _workspaceService: WorkspaceNewService,
    _itemService: AbstractItemService,
    _dialog: MatDialog,
    private _quoteService: QuoteService,
    private _datePipe: DatePipe,
    private _configService: ConfigService,
  ) {
    super(_workspaceService, _dialog, _itemService);
    this.workspaceService = _workspaceService;
    this.dialog = _dialog;
    this.model.quote = '';
  }

  ngOnInit() {
    this.getConfigWhiteLabel();
  }

  ngOnDestroy() {
    if (this.hasSubscribeBook) {
      this.hasSubscribeBook = false;
    }
    if (this.hasSubscribeAggregated) {
      this.hasSubscribeAggregated = false;
    }
    this.unsubscribeQuote();
  }

  getConfigWhiteLabel() {
    const configBook = this._configService.getCookieConfigCards(this.data.type);
    if (configBook && configBook.length > 0) {
      const indexTemp = configBook.findIndex(x => x.bookIdComp === this.data.id);
      if (indexTemp >= 0) {
        this.tabIndex = configBook[indexTemp].bookTabIndex;
        const value = { index: this.tabIndex };
        this.changeTab(value);
      } else {
        this.saveConfigCard(this.data.type, this.data.id, this.tabIndex);
      }
    } else {
      this.saveConfigCard(this.data.type, this.data.id, this.tabIndex);
    }
    if (this.data && this.data.symbol) {
      this.model.quote = this.data.symbol;
      this.subscribeQuote(this.model.quote);
    } else {
      // TODO: Feature desabilitada
      // this._route.queryParams.subscribe(params => {
      //   if (params['symbol']) {
      //     this.newWindow = true;
      //     this.loading = true;
      //     this.symbol = params['symbol'];
      //     this.setQuote(this.symbol);
      //   }
      // });
    }
  }

  selectAsset(event) {
    if (event) {
      if (this.data) {
        this.data.symbol = event.symbol;
      }
      if (event.symbol || event.symbol === '') {
        if (event.symbol === '' && this.oldSymbolTemp !== undefined) {
          super.updateOnDemand(this.data.symbol, event.symbol);
          this.oldSymbolTemp = undefined;
        }
        if (this.model.quote && this.model.quote.toLowerCase() !== event.symbol.toLowerCase()) {
          this.resetQuote();
        }
        this.subscribeQuote(event.symbol);
      }
    }
  }

  subscribeQuote(symbol: string) {
    if (symbol) {
      symbol = AppUtils.trimStart(symbol);
      this.oldSymbolTemp = this.model.quote ? this.model.quote : '';
      if (this.oldSymbolTemp && symbol && this.oldSymbolTemp.toLowerCase() === symbol.toLowerCase() && this._subscriptionQuote) {
        return;
      }
      if (symbol.toLowerCase() === 'invalid' || symbol === '') {
        this.hiddenInvalid = false;
        this.resetQuote();
        this.model.quote = '';
        return;
      }
      this.model.quote = symbol;
      const msgItem = this._quoteService.subscribeQuote(this.model.quote, this.componentName);
      if (msgItem !== undefined && msgItem !== '') {
        this.resetQuote();
        return;
      }
      this.initialPrice = true;
      this.isUpdateOnDemand = false;
      this.loadingImgName = true;
      this.isSubscribeBook = false;
      this._subscriptionQuote = this._quoteService.messagesQuote
        .subscribe((msg: MessageQuote) => {
          if (msg && msg.errorMessage && (this.model.quote && msg.symbol.toLowerCase() === this.model.quote.toLowerCase())) {
            this._quoteService.unsubscribeQuote(msg.symbol.toLowerCase(), this.componentName);
            this.model.quote = null;
            this.resetQuote();
          } else if (msg !== undefined && msg.symbol != null && msg.symbol === this.model.quote) {
            this.messageQuote = msg;
            this.model.quotationForm = AppUtils.convertNumberAux(msg.quotationForm);
            this.model.contractMultiplier = AppUtils.convertNumberAux(msg.contractMultiplier);

            if (this.loadingImgName) {
              this.imgName = './assets/images/symbols/' + AppUtils.getImageSymbol(this.model.quote, msg.marketType).toUpperCase() + '.PNG';
              this.loadingImgName = false;
            }
            if (!this.isUpdateOnDemand) {
              this.isUpdateOnDemand = true;
              super.updateOnDemand(this.oldSymbolTemp, this.model.quote);
            }
            if (!this.isSubscribeBook) {
              this.isSubscribeBook = true;
              if (this.tabIndex === 1 || this.tabIndex === 2) {
                if (this.hasSubscribeBook) {
                  this.hasSubscribeBook = false;
                }
                this.hasSubscribeAggregated = true;
              } else {
                if (this.hasSubscribeAggregated) {
                  this.hasSubscribeAggregated = false;
                }
                this.hasSubscribeBook = true;
              }
            }
            this.hiddenInvalid = false;
            this.variation = this.messageQuote.variation ? this.messageQuote.variation : '-';
            this.coinVariation = this.messageQuote.coinVariation && this.messageQuote.coinVariation.toString() !== '-'
              ? Number(this.messageQuote.coinVariation.toString().replace(',', '.')) : 0.0;
            if (this.messageQuote.description && this.messageQuote.description !== '' && this.messageQuote.marketType === Constants.MARKET_CODE_BOVESPA) {
              this.company = this.messageQuote.description + ' ' + this.messageQuote.classification;
            } else {
              this.company = this.messageQuote.description;
            }
            this.tickSize = this.messageQuote.tickSize && this.messageQuote.marketType && this.messageQuote.marketType === MarketEnum.BITCOIN ? 3 :
              this.messageQuote.tickSize ? this.messageQuote.tickSize : 2;
            if (this.messageQuote.lastTrade && this.messageQuote.lastTrade.toString() !== '-' && this.messageQuote.lastTrade.toString() !== '0,00'
              && this.messageQuote.lastTrade.toString() !== '0') {
              const lastTradeNumber = AppUtils.convertNumber(this.messageQuote.lastTrade.toString().replace('.', ''));
              this.messageQuote.lastTrade = AppUtils.convertToNumber(lastTradeNumber.toString(), this.tickSize);
              this.lastTrade = AppUtils.convertNumberToCurrency(lastTradeNumber, this.tickSize);
            } else {
              if (this.messageQuote.lastTrade && this.messageQuote.lastTrade.toString() === '-' || Number(this.messageQuote.lastTrade) <= 0) {
                const lastTradeNumber = AppUtils.convertNumber(this.messageQuote.previous.toString().replace('.', ''));
                this.messageQuote.lastTrade = AppUtils.convertToNumber(lastTradeNumber.toString(), this.tickSize);
                this.lastTrade = AppUtils.convertNumberToCurrency(lastTradeNumber, this.tickSize);
              } else {
                this.lastTrade = 0;
                this.model.price = this.lastTrade;
              }
            }
            if (this.messageQuote.dateLastNegotiation) {
              const today = this._datePipe.transform(new Date(), 'dd/MM/yyyy');
              this.showVariation = today === this.messageQuote.dateLastNegotiation ? true : false;
            } else {
              this.showVariation = true;
            }
            if (this.messageQuote.theoryPrice && (this.messageQuote.theoryPrice > 0 ||
              (this.messageQuote.theoryPrice.toString() !== '-' && Number(this.messageQuote.theoryPrice.toString().replace(',', '.'))))) {
              this.priceTheory = AppUtils.convertBrCurrencyToNumber(this.messageQuote.theoryPrice.toString(), ',');
              this.model.auctionHammer = true;
              this.timeToOpen = this.messageQuote.timeToOpen;
              let previousConst = 0;
              if (this.messageQuote.previous && this.messageQuote.previous.toString() !== '-') {
                previousConst = AppUtils.convertBrCurrencyToNumber(this.messageQuote.previous.toString(), ',');
              }
              if (this.priceTheory > 0 && previousConst > 0) {
                let varTheoryTemp = ((this.priceTheory / previousConst) - 1) * 100;
                if (varTheoryTemp !== 0) {
                  varTheoryTemp = Number(Number(varTheoryTemp).toFixed(2));
                  this.varTheory = AppUtils.convertNumberToCurrency(varTheoryTemp, null, '');
                }
              }
            } else {
              this.priceTheory = 0;
              this.varTheory = null;
              this.timeToOpen = null;
              this.model.auctionHammer = false;
            }
            this.valueInitBookStaircase.symbol = this.messageQuote.symbol;
            this.valueInitBookStaircase.minimumIncrement = this.messageQuote.minimumIncrement;
            this.valueInitBookStaircase.high = this.messageQuote.high;
            this.valueInitBookStaircase.low = this.messageQuote.low;
            this.valueInitBookStaircase.open = this.messageQuote.open;
            this.valueInitBookStaircase.marketType = this.messageQuote.marketType;
            this.valueInitBookStaircase.lastTrade = this.messageQuote.lastTrade;
            this.valueInitBookStaircase.previous = this.messageQuote.previous;
            if (this.loading) {
              setTimeout(() => { this.loading = false; }, 300);
            }
          }
        });
    }
  }

  unsubscribeQuote() {
    if (this._subscriptionQuote) {
      this._quoteService.unsubscribeQuote(this.model.quote, this.componentName);
      this._subscriptionQuote.unsubscribe();
    }
  }

  resetQuote() {
    this.unsubscribeQuote();
    this.company = null;
    this.imgName = null;
    this.hiddenInvalid = false;
    this.showVariation = false;
    this.priceTheory = null;
    this.model.auctionHammer = false;
    this.timeToOpen = null;
    this.lastTrade = 0;
    this.variation = 0.0;
    this.coinVariation = 0;
    if (this.hasSubscribeBook) {
      this.hasSubscribeBook = false;
    }
    if (this.hasSubscribeAggregated) {
      this.hasSubscribeAggregated = false;
    }
    this.model.quote = null;
  }

  changeTab(value) {
    if (value && value.index >= 0) {
      if (this.tabIndex !== value.index) {
        this.saveConfigCard(this.data.type, this.data.id, value.index);
      }
      this.tabIndex = value.index;
      if (this.model.quote) {
        if (this.tabIndex === 0) {
          if (this.hasSubscribeAggregated) {
            this.hasSubscribeAggregated = false;
          }
          this.hasSubscribeBook = true;
        } else {
          if (this.hasSubscribeBook) {
            this.hasSubscribeBook = false;
          }
          this.hasSubscribeAggregated = true;
        }
      }
    }
  }

  saveConfigCard(componentName: string, bookIdComp: number, bookTabIndex: number) {
    const configCards: ConfigCardsModel = { bookIdComp: bookIdComp, bookTabIndex: bookTabIndex };
    this._configService.setCookieConfigCards(componentName, configCards);
  }

  // TODO: Feature Desativado
  // closeSheet() {
  //   if (this.windowActive != null) {
  //     this.windowActive.close();
  //   }
  // }

  // COMPONENT
  // TODO: Feature Desativado
  // openNewWindow() {
  //   if (this.symbol) {
  //     const options = 'width=300px, height=498px';
  //     const parameters = '?symbol=' + this.symbol;
  //     if (this.windowActive == null || this.windowActive.closed) {
  //       super.getNewWindow('book', parameters, options, this.data.id).subscribe(window => {
  //         this.windowActive = window;
  //       });
  //     } else {
  //       this.windowActive.focus();
  //     }
  //   } else {
  //     this._configService.systemNotificationMessage('', Constants.WORKSPACE_MSG025,  Constants.ALERT_TYPE.warn);
  //   }
  // }

}
